<script lang="ts">
  import { track } from "../../helpers/mixpanel";
  import SettingsIcon from "../icons/SettingsIcon.svelte";
  import TextNew from "../TextNew.svelte";
  import Tooltip from "../Tooltip.svelte";
  import SettingsMenu from "./SettingsMenu.svelte";

  export let isMenuExpanded: boolean;

  let showSettings = false;

  function toggleShowSettings() {
    showSettings = !showSettings;
    track("nav_settings_click");
  }

  function hideSettings() {
    showSettings = false;
  }

  $: expandedMenu = isMenuExpanded;
  $: show = showSettings;
</script>

<div class="container">
  <button class="link settings" on:click={toggleShowSettings}>
    <SettingsIcon />
    {#if expandedMenu}
      <TextNew as="span" size="s" weight="medium">settings</TextNew>
    {/if}
  </button>

  <Tooltip {show} position="right-bottom" hide={hideSettings} margin="0 0 0 8px">
    <SettingsMenu />
  </Tooltip>
</div>

<style>
  .container {
    position: relative;
  }

  .link {
    background: none;
    width: 100%;
    outline: none;
    border: none;
    color: var(--rekki-dark);
    opacity: 0.6;
    font-size: 19px;
    line-height: 24px;
    letter-spacing: -0.5px;
    font-family: "REKKI-Medium";
  }

  .link:hover {
    opacity: 1;
  }
  .settings {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
</style>
